import type React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import type translations from "../../translations/translations.json";

type TranslationKeys = keyof typeof translations.en;

interface PasswordInputProps {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showPassword: boolean;
  setShowPassword: (show: boolean) => void;
  disabled?: boolean;
  required?: boolean;
  margin?: "none" | "dense" | "normal";
  fullWidth?: boolean;
  sx?: object;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  name,
  value,
  onChange,
  showPassword,
  setShowPassword,
  disabled = false,
  required = true,
  margin = "normal",
  fullWidth = true,
  sx = {},
}) => {
  const { t } = useTranslation();

  return (
    <TextField
      margin={margin}
      required={required}
      fullWidth={fullWidth}
      label={t(label as TranslationKeys)}
      type={showPassword ? "text" : "password"}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={`toggle ${name} visibility`}
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
